import { allotmentSummaryConstants } from '../../_constants';
import { allotmentSummaryService } from '../../_services';

export const getAllotmentSummaryAction = {
    getAllotmentSummaryHandler
};

function getAllotmentSummaryHandler(callback) {
    return dispatch => {
        dispatch(request());
        allotmentSummaryService.getAllotmentSummaryHandler()
            .then(
                getAllotmentSummary => {
                    dispatch(success(getAllotmentSummary));

                    callback(getAllotmentSummary.data.message.user_credits_list)
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: allotmentSummaryConstants.REQUEST_ALLOTMENT_SUMMARY } }
    function success(getAllotmentSummary) { return { type: allotmentSummaryConstants.RECEIVE_ALLOTMENT_SUMMARY, getAllotmentSummary } }
    function failure(error) { return { type: allotmentSummaryConstants.ALLOTMENT_SUMMARY_ERROR, error } }
}




// WEBPACK FOOTER //
// ./src/_actions/AllotmentSummary/getAllotmentSummary.action.js